// API Configuration for Survey Taker Platform
export const apiConfig = {
  // API Base URL from environment variable with fallback
  get baseUrl() {
    return process.env.REACT_APP_API_BASE_URL || 'https://b3h6fhpft7.execute-api.us-east-2.amazonaws.com/dev';
  },
  
  // API Endpoints
  endpoints: {
    surveyExecute: '/survey/execute',
    surveyStatus: (executionId: string) => `/survey/status/${executionId}`,
    externalSurveyInitiate: '/external-survey/initiate',
    externalSurveyPoll: (interactionId: string) => `/external-survey/poll/${interactionId}`,
  }
};

export default apiConfig;

